
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gY9Xv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");




const $c2f26f1fdfbccb16$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    caption: {
        id: "change-history-macro.caption",
        defaultMessage: "Change History"
    },
    pageVersionColumn: {
        id: "change-history-macro.page-version-column",
        defaultMessage: "Page Version"
    },
    dateColumn: {
        id: "change-history-macro.date-column",
        defaultMessage: "Date"
    },
    commentColumn: {
        id: "change-history-macro.comment-column",
        defaultMessage: "Comment"
    },
    currentVersion: {
        id: "change-history-macro.current-version",
        defaultMessage: "Current Version"
    },
    currentVersionWithNumber: {
        id: "change-history-macro.current-version-with-number",
        defaultMessage: "Current Version (v. {versionNumber})"
    },
    versionWithNumber: {
        id: "change-history-macro.version-with-number",
        defaultMessage: "v. {versionNumber}"
    },
    unsupportedContent: {
        id: "change-history-macro.unsupported-content",
        defaultMessage: "Change history macro can only be used in pages, live docs, or blog posts."
    },
    invalidParams: {
        id: "change-history-macro.invalid-params",
        defaultMessage: "Change history macro cannot be rendered with invalid params."
    },
    loading: {
        id: "change-history-macro.loading",
        defaultMessage: "Loading change history"
    },
    error: {
        id: "change-history-macro.error",
        defaultMessage: "We couldn\u2019t load change history."
    },
    unknownUser: {
        id: "change-history-macro.unknown-user",
        defaultMessage: "Unknown user"
    },
    moreVersionsAvailable: {
        id: "change-history-macro.more-versions-available",
        defaultMessage: "Showing {count} versions."
    },
    viewMoreVersions: {
        id: "change-history-macro.view-more-versions",
        defaultMessage: "View more..."
    },
    loadMoreError: {
        id: "change-history-macro.load-more-error",
        defaultMessage: "We couldn\u2019t load more versions."
    }
});



const $321696733d24b05e$var$SUPPORTED_CONTENT_TYPES = new Set([
    'page',
    'blogpost'
]);
const $321696733d24b05e$var$LIVE_DOC_SUBTYPE = 'live';
const $321696733d24b05e$var$hasAccountId = (author)=>'accountId' in author;
const $321696733d24b05e$export$2a82fc0c7d5014fc = (formatMessage)=>new Error(formatMessage((0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).unsupportedContent));
const $321696733d24b05e$export$b4b0dbb51bab3de9 = (content)=>{
    if (!content) return false;
    return $321696733d24b05e$var$SUPPORTED_CONTENT_TYPES.has(content.type ?? '') || content.subType === $321696733d24b05e$var$LIVE_DOC_SUBTYPE;
};
const $321696733d24b05e$export$2c8f257f76f536e9 = (author, formatMessage)=>author?.displayName || formatMessage((0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).unknownUser);
const $321696733d24b05e$export$5879f87d8125a540 = (author)=>{
    if (!author || !$321696733d24b05e$var$hasAccountId(author)) return undefined;
    return author.accountId ?? undefined;
};
const $321696733d24b05e$var$toChangeHistoryVersion = (version)=>{
    if (!version?.number) return null;
    return {
        by: version.by,
        friendlyWhen: version.friendlyWhen ?? '',
        message: version.message ?? '',
        number: version.number,
        when: version.when ?? ''
    };
};
const $321696733d24b05e$var$isChangeHistoryVersion = (version)=>Boolean(version);
const $321696733d24b05e$export$810dd21f3ff2864 = (contentHistory, currentVersion)=>{
    const versions = (contentHistory?.nodes ?? []).filter($321696733d24b05e$var$isChangeHistoryVersion);
    return versions.length ? versions : [
        $321696733d24b05e$var$toChangeHistoryVersion(currentVersion)
    ].filter($321696733d24b05e$var$isChangeHistoryVersion);
};









var $4aRua = parcelRequire("4aRua");


var $b3j2Y = parcelRequire("b3j2Y");

const $66b16a92cc1231dd$export$8fccf26317afe561 = ({ error: error, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, children)));


/* ChangeHistoryTable.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $ad7Ou = parcelRequire("ad7Ou");


var $w6R6I = parcelRequire("w6R6I");





var $dinVW = parcelRequire("dinVW");





var $1NBp8 = parcelRequire("1NBp8");












var $a6t12 = parcelRequire("a6t12");


var $jJK3p = parcelRequire("jJK3p");


const $367253f7bad1cd40$export$2883abe78c21e4ad = ({ author: author, isCurrent: isCurrent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const authorName = (0, $321696733d24b05e$export$2c8f257f76f536e9)(author, formatMessage);
    const accountId = (0, $321696733d24b05e$export$5879f87d8125a540)(author);
    const content = accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: accountId,
        fullName: authorName,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
        userId: accountId,
        fullName: authorName,
        behavior: "link",
        isUnderlinedByDefault: false
    })) : authorName;
    return isCurrent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, content);
};


/* VersionComment.tsx generated by @compiled/babel-plugin v3.0.2 */ 








const $8b8188e07820012f$var$styles = {
    commentCell: "_1ANEUSzUZr _3W2Oc8wPeg"
};
const $8b8188e07820012f$export$768735e8385a4463 = ({ version: version, isCurrent: isCurrent })=>{
    if (!version.message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8b8188e07820012f$var$styles.commentCell
    }, isCurrent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, version.message) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, version.message));
};












var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $1e7716dabc856d54$export$369bbea6b86347c9 = ({ version: version, isCurrent: isCurrent })=>{
    const sessionData = (0, $bQm3c.useSessionData)();
    // Session data is shared by SSR and hydration; runtime timezones can differ.
    const content = version.when ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
        value: new Date(version.when),
        // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        ...(0, $9wGTI.fg)('cc-dlp-fix-change-history-macro-ssr-date-bug') ? {
            timeZone: sessionData.timeZone || sessionData.tenantTimeZone || undefined
        } : {},
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    }) : version.friendlyWhen;
    return isCurrent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, content);
};


/* VersionLink.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $8lYIw = parcelRequire("8lYIw");


const $597ed89013dd7896$var$styles = {
    versionCell: "_0LQT5E2ADO"
};
const $597ed89013dd7896$export$1caa319363788f6b = ({ version: version, href: href, isCurrent: isCurrent })=>{
    const content = isCurrent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).currentVersionWithNumber,
        values: {
            versionNumber: version.number
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).versionWithNumber,
        values: {
            versionNumber: version.number
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $597ed89013dd7896$var$styles.versionCell
    }, isCurrent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
        href: href
    }, content)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
        href: href
    }, content)));
};



const $38303fdd3b083914$var$styles = {
    tableWrapper: "_39xV02N91d",
    table: "_39xV02N91d _2i6rxZQkF9",
    caption: "_2fwxA5ecOK",
    headerCell: "_4c065U2ADO _2Y7lL42ADO _4auqkJNvrM _2yjt2x6wH8 _3mHaMX9r67 _2fwxA5ecOK _1RrJLiBwqQ",
    cell: "_4c065U2ADO _2Y7lL42ADO _1RrJLiBwqQ",
    separatedCell: "_0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67",
    nowrapCell: "_1ANEUSLRg7",
    authorLine: "_0rIjykFQfX",
    moreVersionsNote: "_43nrzT1Y8M"
};
const $38303fdd3b083914$export$81af7ba781437442 = ({ versions: versions, spaceKey: spaceKey, contentId: contentId, hasNextPage: hasNextPage, onViewMore: onViewMore, isLoadingNextPage: isLoadingNextPage, loadNextPageError: loadNextPageError })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $38303fdd3b083914$var$styles.tableWrapper,
        testId: "change-history-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "table",
        xcss: $38303fdd3b083914$var$styles.table
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "caption",
        xcss: $38303fdd3b083914$var$styles.caption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).caption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "thead"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "th",
        scope: "col",
        xcss: $38303fdd3b083914$var$styles.headerCell
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).pageVersionColumn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "th",
        scope: "col",
        xcss: $38303fdd3b083914$var$styles.headerCell
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).dateColumn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "th",
        scope: "col",
        xcss: $38303fdd3b083914$var$styles.headerCell
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).commentColumn)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tbody"
    }, versions.map((version, index)=>{
        const isCurrent = index === 0;
        const href = (0, $1NBp8.CONTENT_HISTORY).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        }, {
            query: {
                version1: version.number
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "tr",
            key: version.number,
            testId: `change-history-row-${version.number}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: (0, $w6R6I.cx)($38303fdd3b083914$var$styles.cell, !isCurrent && $38303fdd3b083914$var$styles.separatedCell)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $38303fdd3b083914$var$styles.nowrapCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $597ed89013dd7896$export$1caa319363788f6b), {
            version: version,
            href: href,
            isCurrent: isCurrent
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: (0, $w6R6I.cx)($38303fdd3b083914$var$styles.cell, !isCurrent && $38303fdd3b083914$var$styles.separatedCell)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $38303fdd3b083914$var$styles.nowrapCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e7716dabc856d54$export$369bbea6b86347c9), {
            version: version,
            isCurrent: isCurrent
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: (0, $w6R6I.cx)($38303fdd3b083914$var$styles.cell, !isCurrent && $38303fdd3b083914$var$styles.separatedCell)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $38303fdd3b083914$var$styles.authorLine
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $367253f7bad1cd40$export$2883abe78c21e4ad), {
            author: version.by,
            isCurrent: isCurrent
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b8188e07820012f$export$768735e8385a4463), {
            version: version,
            isCurrent: isCurrent
        }))));
    })))), hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $38303fdd3b083914$var$styles.moreVersionsNote
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).moreVersionsAvailable,
        values: {
            count: versions.length
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        "aria-label": formatMessage((0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).viewMoreVersions),
        appearance: "default",
        isDisabled: isLoadingNextPage,
        isLoading: isLoadingNextPage,
        onClick: onViewMore,
        testId: "change-history-view-more"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).viewMoreVersions))))), loadNextPageError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66b16a92cc1231dd$export$8fccf26317afe561), {
        error: loadNextPageError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).loadMoreError)));
};












var $1l0kj = parcelRequire("1l0kj");





var $lfoFx = parcelRequire("lfoFx");


const $69974985889abca3$export$62aa48085237e36f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.100",
        testId: "change-history-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).loading))));
};



var $k0BFU = parcelRequire("k0BFU");





var $jMyy4 = parcelRequire("jMyy4");


var $eqmIR = parcelRequire("eqmIR");

const $c99284309da698f4$var$toError = (error)=>error instanceof Error ? error : new Error('Failed to load more change history');
const $c99284309da698f4$export$6f4d7fac495c5b65 = ({ contentId: contentId })=>{
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $cozmU.useState)(false);
    const [loadNextPageError, setLoadNextPageError] = (0, $cozmU.useState)(null);
    const isLoadingNextPageRef = (0, $cozmU.useRef)(false);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)((0, $k0BFU.default), {
        variables: (0, $eqmIR.buildChangeHistoryDataQueryVariables)(contentId ?? ''),
        skip: !contentId,
        fetchPolicy: 'cache-first',
        __callerPackage__: "change-history-macro"
    });
    (0, $cozmU.useEffect)(()=>{
        setLoadNextPageError(null);
        isLoadingNextPageRef.current = false;
        setIsLoadingNextPage(false);
    }, [
        contentId
    ]);
    const pageInfo = data?.contentHistory?.pageInfo;
    const loadNextPage = (0, $cozmU.useCallback)(async ()=>{
        if (!contentId || !pageInfo?.hasNextPage || !pageInfo.endCursor || isLoadingNextPageRef.current) return;
        isLoadingNextPageRef.current = true;
        setIsLoadingNextPage(true);
        setLoadNextPageError(null);
        try {
            await fetchMore({
                variables: {
                    contentId: contentId ?? '',
                    after: pageInfo.endCursor,
                    first: (0, $eqmIR.CHANGE_HISTORY_PAGE_SIZE)
                },
                updateQuery: (previousData, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult?.contentHistory) return previousData;
                    if (!previousData.contentHistory) return fetchMoreResult;
                    return {
                        ...previousData,
                        contentHistory: {
                            ...fetchMoreResult.contentHistory,
                            nodes: [
                                ...previousData.contentHistory.nodes ?? [],
                                ...fetchMoreResult.contentHistory.nodes ?? []
                            ]
                        },
                        singleContent: previousData.singleContent ?? fetchMoreResult.singleContent
                    };
                }
            });
        } catch (fetchMoreError) {
            setLoadNextPageError($c99284309da698f4$var$toError(fetchMoreError));
        } finally{
            isLoadingNextPageRef.current = false;
            setIsLoadingNextPage(false);
        }
    }, [
        contentId,
        fetchMore,
        pageInfo?.endCursor,
        pageInfo?.hasNextPage
    ]);
    return {
        data: data,
        loading: loading,
        error: error ?? null,
        loadNextPage: loadNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPageError: loadNextPageError
    };
};


const $d95476370a17a8eb$var$ChangeHistoryMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { data: data, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage, loadNextPageError: loadNextPageError } = (0, $c99284309da698f4$export$6f4d7fac495c5b65)({
        contentId: contentId
    });
    const versions = (0, $cozmU.useMemo)(()=>(0, $321696733d24b05e$export$810dd21f3ff2864)(data?.contentHistory, data?.singleContent?.version), [
        data?.contentHistory,
        data?.singleContent?.version
    ]);
    const renderMacroExperienceFailure = (macroError, messageDescriptor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: macroError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66b16a92cc1231dd$export$8fccf26317afe561), {
            error: macroError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), messageDescriptor)));
    if (!contentId) {
        const invalidParamsError = new Error(formatMessage((0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).invalidParams));
        return renderMacroExperienceFailure(invalidParamsError, (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).invalidParams);
    }
    if (loading && !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69974985889abca3$export$62aa48085237e36f), null);
    if (error) return renderMacroExperienceFailure(error, (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).error);
    if (!(0, $321696733d24b05e$export$b4b0dbb51bab3de9)(data?.singleContent)) {
        const unsupportedContentError = (0, $321696733d24b05e$export$2a82fc0c7d5014fc)(formatMessage);
        return renderMacroExperienceFailure(unsupportedContentError, (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).unsupportedContent);
    }
    const spaceKey = data?.singleContent?.space?.key ?? macroDefaultProps.spaceKey;
    if (!spaceKey) {
        const dataError = new Error(formatMessage((0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).error));
        return renderMacroExperienceFailure(dataError, (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).error);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-fabric-macro": attributes?.macroId,
        "data-macro-body": "",
        testId: "change-history-macro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38303fdd3b083914$export$81af7ba781437442), {
        versions: versions,
        spaceKey: spaceKey,
        contentId: contentId,
        hasNextPage: Boolean(data?.contentHistory?.pageInfo?.hasNextPage),
        onViewMore: loadNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPageError: loadNextPageError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
const $d95476370a17a8eb$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c2f26f1fdfbccb16$export$a7357cdd1f0b0168).error);
const $d95476370a17a8eb$export$9a8535f7a382705 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $d95476370a17a8eb$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d95476370a17a8eb$var$ChangeHistoryMacroRendererComponent, props));
module.exports["ChangeHistoryMacroRenderer"] = $d95476370a17a8eb$export$9a8535f7a382705;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $a6t12 = parcelRequire("a6t12");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== style || $[13] !== teamsAppPersonProfileUrl || $[14] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: teamsAppPersonProfileUrl,
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = style;
        $[13] = teamsAppPersonProfileUrl;
        $[14] = userId;
        $[15] = t7;
    } else t7 = $[15];
    const renderNameComponent = t7;
    let t8;
    if ($[16] !== fullName || $[17] !== hasViewUserProfilePermission || $[18] !== isAnonymous || $[19] !== renderNameComponent || $[20] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[16] = fullName;
        $[17] = hasViewUserProfilePermission;
        $[18] = isAnonymous;
        $[19] = renderNameComponent;
        $[20] = userId;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    let t0;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== to || $[8] !== url) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: url,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = to;
        $[8] = url;
        $[9] = t0;
    } else t0 = $[9];
    return t0;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("k0BFU", function(module, exports) {
/**
 * @generated SignedSource<<f53a70cd602b186fb3992ed10ea55417>>
 * @relayHash 5b6afbfce3854e9bcb1bde3de2a8c2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e052df92530525eaef9def99c51a000bfaed4288154845f27656bb5592202c43
const $70dced0078029077$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "KnownUser"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "UnknownUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "when"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "number"
    }, v12 = [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ]
        },
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v14 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft",
                "archived"
            ]
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ]
        },
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v12 /*: any*/ 
                        },
                        v13 /*: any*/ 
                    ]
                },
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": v12 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v18 /*: any*/ 
                        },
                        v13 /*: any*/ 
                    ]
                },
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": v18 /*: any*/ 
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5b6afbfce3854e9bcb1bde3de2a8c2a7",
            "id": "e052df92530525eaef9def99c51a000bfaed4288154845f27656bb5592202c43",
            "metadata": {},
            "name": "useChangeHistoryDataQuery",
            "operationKind": "query",
            "text": "query useChangeHistoryDataQuery($contentId:ID!,$after:String,$first:Long){contentHistory(contentId:$contentId,after:$after,first:$first){nodes{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},pageInfo{hasNextPage,endCursor}},singleContent(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){type,subType,space{key,id},version{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},id}}"
        }
    };
}();
$70dced0078029077$var$node.hash = "5c74bea9bed287cb9acb1aedf532afd9";
var $70dced0078029077$export$2e2bcd8739ae039 = $70dced0078029077$var$node;
module.exports["default"] = $70dced0078029077$export$2e2bcd8739ae039;

});

parcelRegister("eqmIR", function(module, exports) {
const $5dff6ba48bb7564d$export$9266850431e06b56 = 100;
const $5dff6ba48bb7564d$export$70f9f93372f73c04 = (contentId)=>({
        contentId: contentId,
        after: null,
        first: $5dff6ba48bb7564d$export$9266850431e06b56
    });
module.exports["CHANGE_HISTORY_PAGE_SIZE"] = $5dff6ba48bb7564d$export$9266850431e06b56;
module.exports["buildChangeHistoryDataQueryVariables"] = $5dff6ba48bb7564d$export$70f9f93372f73c04;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});


//# sourceMappingURL=ChangeHistoryMacroRenderer.aa617e39.js.map
